module.exports = {"oops":"Ooops...","oopsTitle":"Something went wrong","notFound":"Not found","status":{"400":"Error connecting to the Tax Office, please try again in a few seconds!","401":"The login information is incorrect.","default":"Error connecting to the Tax Office, please try again in a few seconds!"},"form":{"email":{"required":"Email is required.","validate":"Invalid information at email number "},"taxCode":{"validate":"Invalid tax code format"}},"company":{"update":{"400":"The business information already exists in the system.","default":"Error occurred while updating."}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/error.json
// module id = wKfS
// module chunks = 23